import React, { useContext } from "react";
import { Modal, CopyText } from "@dtpk-cc/components";
import "@dtpk-cc/components/dist/components/Modal/Modal.css";
import "@dtpk-cc/components/dist/components/A11yText/A11yText.css";

import { ModalContext } from "../../contexts/ModalContext";
import styles from './LegalTextModal.module.css';

export default function LegalTextModal() {
  const {
    isModalOpen,
    setIsModalOpen,
    openModal,
    headline,
    content,
    setHeadline,
    setContent,
  } = useContext(ModalContext);

  const closed = () => {
    setIsModalOpen(false);
    setHeadline("");
    setContent("");
  };

  return (
    <Modal
      isOpen={isModalOpen}
      beforeOpen={openModal}
      afterClose={closed}
      buttonProps={{ "data-button": "close-button" }}
      containerProps={{ "data-modal": "legal-text" }}
      zIndex={3000}
    >
      <Modal.Section>
        <>
          <CopyText
            variants={CopyText.Variant.highlight}
            dangerouslySetInnerHTML={{ __html: headline }}
          />
          <div className={styles.list}>
            <CopyText dangerouslySetInnerHTML={{ __html: content }}></CopyText>
          </div>
        </>
      </Modal.Section>
    </Modal>
  );
}